// extracted by mini-css-extract-plugin
export default {"container":"ApWbtwStwRGCvBHHbUXRPw==","icon":"nDcdez4EayZd8E1hq+A7aw==","newline":"JS38dJpSqdbXRUe6TmJnDA=="};